import S, { eitherShape } from 'common/service/sanctuary';
import React from 'react';
import { node, func } from 'prop-types';
import { connect } from 'react-redux';
import { LoadingWrapper } from 'common/mdc/wrappers';
import { loadUser } from 'common/store/auth/actions';
import {
  getUser,
  isLoading,
} from 'common/store/auth/selectors';
import Login from './login';

class AuthProvider extends React.PureComponent {
  componentDidMount() {
    this.props.loadUser();
  }

  render() {
    const { children, user, loading } = this.props;

    const renderError = error => <Login error={error} />;
    const renderUser = S.maybe(
      <Login />,
      () => children,
    );

    return (
      <LoadingWrapper loading={loading}>
        {
          S.either(
            renderError,
            renderUser,
            user,
          )
        }
      </LoadingWrapper>
    );
  }
}

AuthProvider.propTypes = {
  children: node.isRequired,
  loadUser: func.isRequired,
  user: eitherShape,
};

export default
// S.compose(
connect(
  state => ({
    user: getUser(state),
    loading: isLoading(state),
  }),
  {
    loadUser,
  },
  // ),
)(AuthProvider);
